import { TravelDuration } from "./TravelDuration";
import { DestinationCategory } from "./DestinationCategory";

export interface Airport {
  city: string;
  code: string;
}

export interface DestinationCountry {
  name: string;
  code: string;
}

export enum TripType {
  RoundTrip = "roundTrip",
  OneWay = "oneWay",
}

export enum DateSelectorMode {
  Timeline = "timeline",
  Calendar = "calendar",
}

export enum ConnectionMode {
  Direct = "direct",
  DirectAndOneStop = "directAndOneStop",
}

export interface TravelProfile {
  passportCountry: string;
  visaFreeOnly: boolean;
  easyVisaOnly?: boolean;
}

export interface FlightSearchData {
  travelProfile?: TravelProfile | null;
  airports: Airport[];
  dateFrom: Date | null;
  dateTo: Date | null;
  categories: DestinationCategory[];
  departureCountries: DestinationCountry[];
  destinationAirports: Airport[];
  destinationCountries: DestinationCountry[];
  tripType: TripType;
  travelDuration: TravelDuration;
  minDurationDays: number | null;
  maxDurationDays: number | null;
  connectionMode: ConnectionMode;
  dateSelectorMode: DateSelectorMode; // Timeline or CalendarView
}

const today = new Date();
const currentMonthStart = new Date(today.getFullYear(), today.getMonth(), 1);
const nextMonthEnd = new Date(today.getFullYear(), today.getMonth() + 2, 0);

export const ALL_CATEGORIES: DestinationCategory[] = Object.values(DestinationCategory);

export const initialFlightSearchData: FlightSearchData = {
  airports: [{ city: "Karlsruhe/Baden-Baden", code: "FKB" }],
  dateFrom: currentMonthStart,
  dateTo: nextMonthEnd,
  categories: ALL_CATEGORIES,
  departureCountries: [],
  destinationAirports: [],
  destinationCountries: [],
  tripType: TripType.RoundTrip,
  travelDuration: TravelDuration.MEDIUM,
  minDurationDays: null,
  maxDurationDays: null,
  connectionMode: ConnectionMode.Direct,
  dateSelectorMode: DateSelectorMode.Timeline,   // Default: Timeline
};
